// removed by extract-text-webpack-plugin
module.exports = {"root":"KeepReading__root--3o5fu","icon":"KeepReading__icon--1knnO","wordCount":"KeepReading__wordCount--1PMdk","hide":"KeepReading__hide--2qQxD","showLess":"KeepReading__showLess--2y-8w KeepReading__hide--2qQxD","keepReading":"KeepReading__keepReading--3wXA5","keepReadingOpen":"KeepReading__keepReadingOpen--24exR","keepReadingFixed":"KeepReading__keepReadingFixed--3RBun","bounce":"KeepReading__bounce--12I7r"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Library/KeepReading/KeepReading.css
// module id = ./src/components/Library/KeepReading/KeepReading.css
// module chunks = 2